<template>
  <div>
    <div class="right-box">
      <div class="wechart-box">
        <div class="img">
          <img :src="info.avatar" alt />
          <p v-show="upload" class="uploadImg">上传中.....</p>
          <input ref="imgInput" class="img-input" type="file" accept=".jpg, .gif, .png, .bmp"
            @change="changImg($event)" />
        </div>
        <div class="name">{{ info.nickname }}</div>
        <div>{{ info.login_name }}</div>
        <div class="info-message">
          <ul>
            <li @click="goCollect()">
              <div>{{ list.favorites }}</div>
              <div>收藏</div>
            </li>
            <li @click="goFollows()">
              <div>{{ list.follows }}</div>
              <div>关注</div>
            </li>
            <li @click="goVotes()">
              <div>{{ list.votes }}</div>
              <div>投票</div>
            </li>
          </ul>
        </div>
        <div class="vip-bg">
          <img src="@/assets/img/vip_bg.png" class="img" alt />
          <div class="box">
            <div>
              我的VIP
              <span>
                <img src="@/assets/img/icon_vip.png" alt />
              </span>
            </div>
            <div>
              <p v-if="info.read_pro_expired_at != null">
                <!-- <span>Pro版</span> -->
                {{ info.read_pro_expired_at }}
              </p>
              <p v-if="info.read_ability_expired_at != null">
                <!-- <span>Lite版</span> -->
                {{ info.read_ability_expired_at }}
              </p>
              <p style="margin-top: 6px;" v-if="
                info.read_ability_expired_at == null &&
                info.read_pro_expired_at == null
              ">
                暂无订阅
              </p>
            </div>
            <div>
              <el-button @click="member">订阅/续费</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="wechart-box" style="padding-bottom:0;">
        <ul class="menu">
          <li v-for="(item, i) in menu" :key="i" @click="openDialog(item)">
            <div class="icon">
              <img :src="item.icon" v-if="item.isCurrent == 0" alt />
              <img :src="item.iconCurrent" v-else alt />
            </div>
            <p :class="item.isCurrent == 0 ? '' : 'iscurrent'">
              {{ item.name }}
            </p>
          </li>
        </ul>
      </div>
      <div class="sign-out" @click="signOut">退出</div>
    </div>

    <!-- 弹框 -->
    <div class="loginDialog">
      <!-- 修改昵称 -->
      <el-dialog :visible.sync="editNameDialog" width="420px" :before-close="editNameClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="agreeList editName">
          <h3>修改昵称</h3>
          <el-input placeholder="输入昵称" v-model="editName" maxlength="16"></el-input>
          <el-button @click="editNameBtn">提交</el-button>
        </div>
      </el-dialog>
      <!-- 意见反馈 -->
      <el-dialog :visible.sync="feedBackDialog" width="420px" :before-close="feedBackClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="feedBackList">
          <h3>意见反馈</h3>
          <el-input placeholder="您的问题或建议" type="textarea" :rows="10" v-model="feedList.content" maxlength="500"
            show-word-limit></el-input>
          <div class="box">
            <el-input placeholder="邮箱" v-model="feedList.email"></el-input>
            <el-input placeholder="手机号（选填）" v-model="feedList.contact"></el-input>
            <el-button @click="feedBackBtn">提交</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 修改密码 -->
      <el-dialog :visible.sync="passWordDialog" width="420px" :before-close="passWordClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="feedBackList">
          <h3>修改密码</h3>
          <div class="box">
            <el-form :model="passWordForm" :rules="rules" ref="passWordForm" label-width="100px" class="demo-ruleForm">
              <el-form-item prop="phone">
                <el-input placeholder="手机号" v-model="passWordForm.phone" disabled></el-input>
                <span @click="sendCode" v-if="showBtnCode">发送验证码</span>
                <span v-else>{{ code_ts }}</span>
              </el-form-item>
              <el-form-item prop="code">
                <el-input placeholder="验证码" v-model="passWordForm.code"></el-input>
              </el-form-item>

              <el-form-item prop="passWord">
                <el-input type="password" placeholder="密码为6~16位数字、英文、符号，至少两种组合的字符"
                  v-model="passWordForm.passWord"></el-input>
              </el-form-item>
              <el-form-item prop="again">
                <el-input type="password" placeholder="再次输入密码" v-model="passWordForm.again"></el-input>
              </el-form-item>
            </el-form>
            <el-button @click="editPwd('passWordForm')">确定</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 修改手机号 -->
      <el-dialog :visible.sync="editPhoneDialog" width="420px" :before-close="editPhoneClose"
        :close-on-click-modal="false" class="agreeDialog">
        <div class="feedBackList">
          <h3>更换手机号</h3>
          <div class="box">
            <el-form :model="editPhoneForm" :rules="editPhoneRule" ref="editPhoneForm" label-width="100px"
              class="demo-ruleForm">
              <el-form-item prop="phone">
                <el-input placeholder="请输入新手机号" v-model="editPhoneForm.phone"></el-input>
                <span @click="editPhoneSendCode" style="cursor: pointer;" v-if="showEditPhoneBtn">发送验证码</span>
                <span v-else>{{ phoneCode_ts }}</span>
              </el-form-item>
              <el-form-item prop="code">
                <el-input placeholder="验证码" v-model="editPhoneForm.code"></el-input>
              </el-form-item>

              <el-form-item prop="passWord">
                <el-input type="password" placeholder="当前密码" v-model="editPhoneForm.passWord"></el-input>
              </el-form-item>
            </el-form>
            <el-button @click="editPhoneSubmit('editPhoneForm')">提交</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getlogin,
  getUserInfo,
  getVoucher,
  getUserImage,
  getResetPhone,
  getResetPhoneCode
} from "@/api/public";
import {
  getFeedBack,
  getSubscriptionCode,
  getEditPwd,
  getForgetCode,
  getStatisticsList
} from "@/api/system";
import { getEditName } from "@/api/home";
import VueBus from "@/utils/VueBus.js";
export default {
  inject: ["reload"],
  data() {
    return {
      info: {
        avatar: require("@/assets/img/code.png"),
        name: "黎小雅",
        phone: "19812348227"
      },
      list: {},
      menu: [
        {
          icon: require("@/assets/img/icon_edit_name.png"),
          iconCurrent: require("@/assets/img/icon_edit_name_1.png"),
          name: "修改昵称",
          isCurrent: 0
        },
        {
          icon: require("@/assets/img/icon_edit_password.png"),
          iconCurrent: require("@/assets/img/icon_edit_password_1.png"),
          name: "修改密码",
          isCurrent: 0
        },
        {
          icon: require("@/assets/img/icon_editPhone.png"),
          iconCurrent: require("@/assets/img/icon_editPhone.png"),
          name: "修改手机号",
          isCurrent: 0
        },
        {
          icon: require("@/assets/img/icon_records.png"),
          iconCurrent: require("@/assets/img/icon_records_1.png"),
          name: "购买记录",
          isCurrent: 0
        },
        {
          icon: require("@/assets/img/icon_help.png"),
          iconCurrent: require("@/assets/img/icon_help_1.png"),
          name: "使用帮助",
          isCurrent: 0
        },
        {
          icon: require("@/assets/img/icon_feed_back.png"),
          iconCurrent: require("@/assets/img/icon_feed_back_1.png"),
          name: "意见反馈",
          isCurrent: 0
        },
        // {
        //   icon: require("@/assets/img/icon_code.png"),
        //   iconCurrent: require("@/assets/img/icon_code_1.png"),
        //   name: "激活订阅码",
        //   isCurrent: 0
        // },
        {
          icon: require("@/assets/img/exchange_center.png"),
          iconCurrent: require("@/assets/img/exchange_center.png"),
          name: "兑换中心",
          isCurrent: 0
        }
      ],
      // 弹框
      editNameDialog: false, //修改昵称
      editName: "",
      feedBackDialog: false, //意见反馈
      feedList: {
        content: "",
        email: "", //邮箱
        contact: ""
      },
      id: "",
      passWordDialog: false, //修改密码
      passWordForm: {
        phone: "",
        code: "",
        passWord: "",
        again: ""
      },
      rules: {
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        passWord: [
          {
            required: true,
            message: "请输入密码为6~16位数字、英文、符号，至少两种组合的字符",
            trigger: "blur"
          },
          {
            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\\(\\)])+$)([^(0-9a-zA-Z)]|[\\(\\)]|[a-zA-Z]|[0-9]){6,16}$/,
            message: "请输入密码为6~16位数字、英文、符号，至少两种组合的字符"
          }
        ],
        again: [{ required: true, message: "再次输入密码", trigger: "blur" }]
      },
      agreementList: [
        {
          content:
            "1. 第一财经网向注册用户提供用户评论留言、社区发帖跟帖等服务。未实名注册的用户仅可浏览第一财经网内容，不可使用上述服务。"
        },
        {
          content: "2. 用户注册时须提交中国境内手机号。"
        },
        {
          content:
            "3. 注册用户可自主选择昵称、上传头像,昵称和头像经审核通过后显示在前端。"
        },
        {
          content: "4. 注册用户可修改昵称和头像,每30天可修改一次。"
        },
        {
          content: "5. 注册用户发布的内容经审核通过后显示。"
        },
        {
          content:
            "6. 注册用户发布在第一财经网的内容,其知识产权属于发布有关内容的用户,第一财经网有权记录、保存、展示有关内容。"
        },
        {
          content:
            "7. 第一财经网严格保护用户个人隐私,除法律规定的情况之外,不向第三方透露用户注册账号及使用账号过程中产生的个人信息。"
        },
        {
          content:
            "8. 注册用户在第一财经网/APP上的一切活动、发布的一切内容,均须遵守中国法律和互联网信息管理规定。对于违反法律和规定的用户,将采取冻结账号、移交司法等措施。"
        },
        {
          content: "9. 用户注册第一财经网账号,视为同意以上协议。"
        }
      ],
      // 去登陆
      isFlag: false,
      // 账号密码登录
      signLogin: {
        phone: "",
        passWord: ""
      },
      // 快速登录
      fastLogin: {
        phone: "",
        code: ""
      },
      // 修改密码倒计时
      showBtnCode: true,
      code_ts: "获取验证码",
      sec: 60,
      // 修改手机号
      editPhoneDialog: false,
      editPhoneForm: {
        phone: "",
        code: "",
        passWord: ""
      },
      editPhoneRule: {
        phone: [
          { required: true, message: "请输入新手机号", trigger: "blur" },
          {
            pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
            message: "请输入正确的手机号"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        passWord: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ]
      },
      upload: false,
      showEditPhoneBtn: true,
      phoneCode_ts: "获取验证码",
      phoneSec: 60
    };
  },
  methods: {
    member() {
      this.resetSetItem("isActive", 0);
      this.$router.push({ path: "/member" });
    },
    openDialog(scope) {
      if (scope.name == "修改昵称") {
        this.editNameDialog = true;
        this.editName = "";
      } else if (scope.name == "修改密码") {
        this.passWordDialog = true;
        this.passWordForm.phone = this.info.login_name;
        this.passWordForm.code = "";
        this.passWordForm.passWord = "";
        this.passWordForm.again = "";
      } else if (scope.name == "意见反馈") {
        this.feedBackDialog = true;
        this.feedList.content = "";
        this.feedList.email = "";
        this.feedList.contact = "";
      } else if (scope.name == "修改手机号") {
        this.editPhoneDialog = true;
        this.editPhoneForm.phone = "";
        this.editPhoneForm.code = "";
        this.editPhoneForm.passWord = "";
      } else if (scope.name == "使用帮助") {
        this.$router.push({
          name: "help",
          params: { title: scope.name }
        });
      } else if (scope.name == "购买记录") {
        this.$router.push({
          name: "single_copy",
          params: { title: scope.name }
        });
      } else if (scope.name == "激活订阅码") {
        VueBus.$emit("openActivationDialog");
      } else if (scope.name == "兑换中心") {
        this.$router.push({
          name: "exchange"
        });
      }
    },
    // 退出
    signOut() {
      this.resetSetItem("isLogin", false);
      localStorage.removeItem("Authorization");
      localStorage.removeItem("userInfo");
      this.$message.success("退出登录");
      this.resetSetItem("isActive", 0);
    },
    // 关闭修改密码
    passWordClose() {
      this.passWordDialog = false;
    },
    // 关闭意见反馈
    feedBackClose() {
      this.feedBackDialog = false;
    },
    // 意见反馈
    feedBackBtn() {
      if (this.feedList.content == "" || this.feedList.email == "") {
        this.$message.error("反馈内容或邮箱不能为空");
      } else {
        if (this.feedList.contact != "") {
          if (!/^[1][3,4,5,7,8,9][0-9]{9}$/.test(this.feedList.contact)) {
            this.$message.error("手机号输入错误，请输入正确的手机号");
          }
        }
        if (this.feedList.email == "") {
          this.$message.error("请填写邮箱后再次提交");
        } else {
          if (
            !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
              this.feedList.email
            )
          ) {
            this.$message.error("邮箱输入错误，请输入正确的邮箱");
          } else {
            getFeedBack(this.feedList).then(res => {
              if (res.status == 201 || res.status == 200) {
                this.$message.success("意见反馈成功!");
                this.feedBackDialog = false;
              }
            });
          }
        }
      }
    },
    // 关闭修改昵称
    editNameClose() {
      this.editNameDialog = false;
    },
    // 修改昵称接口
    editNameBtn() {
      if (this.editName == "") {
        this.$message.error("请输入昵称");
      } else {
        var userInfo = {};
        userInfo = JSON.parse(localStorage.getItem("userInfo"));
        userInfo.nickname = this.editName;
        var params = {
          avatar: userInfo.avatar,
          id: userInfo.id,
          is_vip: userInfo.has_read_ability,
          login_name: userInfo.login_name,
          nickname: this.editName,
          token: userInfo.token,
          read_ability_expired_at: userInfo.read_ability_expired_at
        };
        getEditName(params).then(res => {
          if (res.status == 201 || res.status == 200) {
            this.resetSetItem("userInfo", JSON.stringify(userInfo));
            this.editNameDialog = false;
            this.reload();
          }
        });
      }
    },
    // 修改密码
    // 发送验证码
    sendCode() {
      if (this.passWordForm.phone == "") {
        this.$message.error("请输入手机号");
      } else {
        var params = {
          login_name: this.passWordForm.phone,
          type: "0"
        };
        getForgetCode(params)
          .then(res => {
            if (res.data.data.returncode === "0000") {
              this.$message.success(res.data.data.returnmsg);
              this.id = res.data.data.id;
              var timer = setInterval(() => {
                this.sec = this.sec - 1;
                this.code_ts = this.sec + "S后重试";
                this.showBtnCode = false;
                if (this.sec === 0) {
                  clearInterval(timer);
                  this.sec = 60;
                  this.code_ts = this.sec + "S后重试";
                  this.showBtnCode = true;
                }
              }, 1000);
            } else {
              this.$message.error(res.data.data.returnmsg);
            }
          })
          .catch(error => {
            this.$message.error("请输入正确的手机号");
          });
      }
    },
    // 修改密码
    editPwd(passWordForm) {
      this.$refs[passWordForm].validate(valid => {
        if (valid) {
          if (this.passWordForm.passWord == this.passWordForm.again) {
            var params = {
              id: this.id,
              login_name: this.passWordForm.phone,
              pwd: this.passWordForm.passWord,
              code: this.passWordForm.code
            };
            getEditPwd(params).then(res => {
              this.passWordDialog = false;
              this.$message.success(res.data.data.returnmsg);
            });
          } else {
            this.$message.error("两次密码输入不一致");
          }
        } else {
          return false;
        }
      });
    },
    // 更换头像
    changImg(e) {
      this.upload = true;
      let file = e.target.files[0];
      getVoucher().then(res => {
        var token = res.data.token;
        var uuid = res.data.uuid;
        var datas = new FormData();
        datas.append("file", file);
        datas.append("uuid", uuid + "_430x430");
        datas.append("token", token);
        getUserImage(datas).then(res => {
          this.upload = false;
          var userInfo = {};
          userInfo = JSON.parse(localStorage.getItem("userInfo"));
          let arr = userInfo.avatar.split("/");
          arr[3] = res.data.key;
          let str = arr.join("/");
          userInfo.avatar = str;
          var params = {
            avatar: str,
            id: userInfo.id,
            is_vip: userInfo.has_read_ability,
            login_name: userInfo.login_name,
            nickname: userInfo.nickname,
            token: userInfo.token,
            read_ability_expired_at: userInfo.read_ability_expired_at
          };
          getEditName(params).then(res => {
            if (res.status == 201 || res.status == 200) {
              this.info.avatar = str;
              this.resetSetItem("userInfo", JSON.stringify(userInfo));
            }
          });
        });
      });
    },
    // 修改手机号
    editPhoneClose() {
      //关闭按钮
      this.editPhoneDialog = false;
    },
    editPhoneSendCode() {
      //获取验证码
      if (this.editPhoneForm.phone == "") {
        this.$message.error("请输入手机号");
      } else {
        var userInfo = JSON.parse(localStorage.getItem("userInfo"));
        var params = {
          yicai_user_id: userInfo.yicai_user_id, //登录账号
          login_name: this.editPhoneForm.phone,
          type: 0
        };
        getResetPhoneCode(params).then(res => {
          if (res.data.data.returncode === "0000") {
            this.$message.success(res.data.data.returnmsg);
            var timer = setInterval(() => {
              this.phoneSec = this.phoneSec - 1;
              this.phoneCode_ts = this.phoneSec + "S后重试";
              this.showEditPhoneBtn = false;
              if (this.phoneSec === 0) {
                clearInterval(timer);
                this.phoneSec = 60;
                this.phoneCode_ts = this.phoneSec + "S后重试";
                this.showEditPhoneBtn = true;
              }
            }, 1000);
          } else {
            this.$message.error(res.data.data.returnmsg);
          }

        }).catch(error => {
          console.log(654321)
          console.log(error)
        });
      }
    },
    editPhoneSubmit(editPhoneForm) {
      this.$refs[editPhoneForm].validate(valid => {
        if (valid) {
          var userInfo = JSON.parse(localStorage.getItem("userInfo"));
          var params = {
            yicai_user_id: String(userInfo.yicai_user_id), //登录账号
            login_name: this.editPhoneForm.phone, //手机号
            type: "0", //注册类型0:手机，1：邮箱
            pwd: this.editPhoneForm.passWord, //密码
            code: this.editPhoneForm.code, //验证码
            token: localStorage.getItem("Authorization")
          };
          // return;
          getResetPhone(params).then(res => {
            this.editPhoneDialog = false;
            if (
              res.data.data.returncode == "1001" ||
              res.data.data.returncode == "1053"
            ) {
              this.$message.error(res.data.data.returnmsg);
            } else {
              this.$message.success("修改成功");
              this.resetSetItem("userInfo", JSON.stringify(res.data.data));
              this.reload();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 跳转收藏
    goCollect() {
      this.$router.push({
        name: "my_collect"
        // params: { title: scope.title, id: this.userId }
      });
    },
    // 关注
    goFollows() {
      this.$router.push({
        name: "my_concerns"
        // params: { title: scope.title, id: this.userId }
      });
    },
    // 投票
    goVotes() {
      this.$router.push({
        name: "my_vote"
        // params: { title: scope.title, id: this.userId }
      });
    }
  },
  created() {
    this.info = JSON.parse(localStorage.getItem("userInfo"));
    getStatisticsList().then(res => {
      this.list = res.data.data;
    });
  }
};
</script>
<style lang="scss" scoped>
.right-box {
  background: #fff;
  text-align: center;
  font-size: 16px;

  .wechart-box {
    padding: 30px;
    border-bottom: 1px solid #eeeeee;

    .img {
      position: relative;

      img {
        border-radius: 50%;
        width: 120px;
        height: 120px;
        // width: 41%;
      }

      .img-input {
        width: 120px;
        height: 120px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        opacity: 0;
        cursor: pointer;
      }
    }

    .name {
      font-size: 20px;
      margin-top: 10px;
      line-height: 30px;
    }

    .info-message {
      margin-top: 30px;

      ul {
        display: flex;
        justify-content: space-around;

        li {
          cursor: pointer;

          div {
            font-size: 14px;
            color: #999999;
          }

          div:first-child {
            font-size: 32px;
            color: #0091ff;
          }
        }
      }
    }

    .vip-bg {
      position: relative;
      margin-top: 14px;

      .img {
        width: 100%;
      }

      .box {
        position: absolute;
        width: 100%;
        top: 50%;
        left: 50%;
        color: #fff;
        transform: translate(-50%, -50%);
        padding-bottom: 8px;

        div:first-child {
          font-size: 18px;
          line-height: 27px;
        }

        div:nth-child(2) {
          font-size: 14px;
          color: #cacaca;
          margin-bottom: 14px;
        }

        div:nth-child(3) {
          .el-button {
            width: 77%;
            background: #0091ff;
            color: #fff;
            border-radius: 23px;
            border: 1px solid #0091ff;
          }
        }
      }
    }

    .menu {
      display: flex;
      flex-wrap: wrap;

      li {
        width: 33.3%;
        margin-bottom: 30px;
        cursor: pointer;

        p {
          margin-top: 4px;
        }

        .iscurrent {
          color: #0091ff;
        }
      }
    }
  }

  .sign-out {
    line-height: 50px;
    font-size: 16px;
    color: #0091ff;
    cursor: pointer;
  }
}

// 弹框
>>>.el-dialog__body {
  padding: 0px 10%;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  text-align: center;
  margin-top: 5px;
}

.dialogBox {
  color: #333333;

  p {
    line-height: 24px;
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 40px;
  }

  .el-input {
    height: 50px;
  }

  .el-button {
    width: 100%;
    border-radius: 23px;
    color: #333333;
    font-size: 16px;
  }

  .el-button:hover {
    background: #ffffff;
    border-color: #dcdfe6;
    color: #606266;
  }

  .forget {
    text-align: right;
    margin-bottom: 20px;
    cursor: pointer;
  }

  >>>.el-input__inner {
    border: none;
    border-bottom: 1px solid #e6e6e6;
    border-radius: 0;
    height: 34px;
    padding-left: 0;
  }

  .phone {
    position: relative;
    height: 60px;

    span {
      position: absolute;
      right: 0;
      top: 4px;
    }
  }

  .code {
    position: relative;
    margin-top: 10px;

    span {
      font-size: 12px;
      position: absolute;
      right: 0;
      top: 10px;
      cursor: pointer;
    }
  }

  .agree {
    margin-top: 10px;
    padding-bottom: 30px;
    cursor: pointer;

    div {
      line-height: 28px;
      color: #0091ff;
    }

    div:first-child {
      color: #b6b6b6;
    }
  }
}

.agreeDialog {
  >>>.el-dialog__body {
    padding: 0px 5%;
    margin-top: 5px;
  }
}

.agreeList {
  color: #333333;

  h3 {
    font-size: 30px;
    line-height: 36px;
  }

  ul {
    text-align: left;
    margin-top: 20px;
    padding-bottom: 40px;

    li {
      line-height: 22px;
      border-bottom: 1px solid #eeeeee;
      padding: 10px 0;
    }
  }
}

.editName {
  padding: 0 30px;

  .el-input {
    margin: 30px 0 30px;
  }

  >>>.el-input__inner {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0px;
    padding: 0;
  }

  .el-button {
    width: 100%;
    border-radius: 23px;
    background: #0099f1;
    color: #fff;
    padding: 14px 20px;
    margin-bottom: 30px;
    font-size: 16px;
  }
}

.feedBackList {
  padding: 0 20px;

  h3 {
    font-size: 30px;
    line-height: 36px;
    margin-bottom: 10px;
  }

  .el-textarea {
    margin-top: 20px;
  }

  >>>.el-textarea__inner {
    border: 1px dashed #dcdfe6;
    border-radius: 0;
  }

  >>>.el-input__inner {
    border: none;
    border-bottom: 1px solid #dcdfe6;
    border-radius: 0px;
    padding: 0;
  }

  .box {
    padding: 20px;

    >>>.el-form-item {
      margin-bottom: 4px;
      position: relative;

      span {
        position: absolute;
        right: 0;
        bottom: 17px;
        font-size: 14px;
      }
    }

    >>>.el-form-item__content {
      margin-left: 0 !important;

      .el-form-item__error {
        top: 80%;
      }
    }
  }

  .el-input {
    margin-bottom: 15px;
  }

  .el-button {
    width: 100%;
    border-radius: 23px;
    background: #0099f1;
    color: #fff;
    padding: 14px 20px;
    margin: 20px 0 10px 0;
    font-size: 16px;
  }

  p {
    margin-bottom: 20px;

    span {
      color: #0091ff;
      cursor: pointer;
    }
  }
}

.uploadImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #3e3e3975;
  width: 130px;
  height: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 130px;
  border-radius: 50%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/dropDownMenu.vue